export const ContactUsScreen = () => {
    return (
        <h1>Contact us</h1>
    );
}